<script lang="ts">
  import Modal from './Modal.svelte'
  import { createEventDispatcher } from 'svelte'

  export let isOpen = false
  export let title = 'Confirmar Acción'
  export let message = '¿Estás seguro de realizar esta acción?'
  export let confirmText = 'Confirmar'
  export let cancelText = 'Cancelar'
  export let type: 'danger' | 'info' = 'danger'

  const dispatch = createEventDispatcher()

  function onConfirm() {
    dispatch('confirm')
  }

  function onCancel() {
    dispatch('cancel')
  }
</script>

<Modal {isOpen} {title} on:close={onCancel}>
  <p class="text-indigo-200/80 mb-8 leading-relaxed">
    {message}
  </p>

  <div class="flex justify-end gap-3">
    <button 
      on:click={onCancel}
      class="px-6 py-3 text-indigo-200/60 hover:text-white transition-colors font-medium"
    >
      {cancelText}
    </button>
    <button 
      on:click={onConfirm}
      class="px-6 py-3 rounded-xl font-bold text-white shadow-lg transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] {type === 'danger' ? 'bg-gradient-to-r from-red-500 to-orange-500 hover:from-red-400 hover:to-orange-400 shadow-red-500/20' : 'bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 hover:from-pink-400 hover:via-purple-400 hover:to-indigo-400 shadow-purple-500/30'}"
    >
      {confirmText}
    </button>
  </div>
</Modal>
